<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        일정
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Schedule</a>
          </li>
      </ul>
    </div>
    <b-card v-if="show">
      <!-- <template slot="header"><i class='fa fa-align-justify'></i> 일정 목록</template> -->

      <b-row>
        <b-col sm="6">
          <span class="text-center" v-b-tooltip.hover title="한 페이지에 보여질 개수를 지정합니다">
            표시 수
            <select v-model="so.perPage" @change="refresh">
              <option value="15">기본 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>

        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'"  size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='site.fqdn';so.skt='FQDN'">FQDN</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='site.name';so.skt='이름'">이름</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          * <b-badge variant="warning">공지</b-badge>
          : 사이트 가용성 및 초과 확인은 하루에 최대 24번으로 제한 될 수 있습니다.
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields_ko" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="fqdn" slot-scope="row">{{row.item.site.fqdn}}</template>
        <template slot="name" slot-scope="row">
          <del v-if="row.item.site.is_del">{{row.item.site.name}}</del>
          <template v-else>{{row.item.site.name}}</template>
        </template>
        <template slot="last_time" slot-scope="row">{{row.item.last_time | sdate}}</template>
        <template slot="due_time" slot-scope="row">{{row.item.due_time | datetime }}</template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="start" :disabled="row.item.is_starting" @click="action('delay', row.item)" size="sm" variant="warning">연기</b-btn>
          <b-btn v-if="start" :disabled="row.item.is_starting" @click="action('start', row.item)" size="sm" variant="danger">시작</b-btn>
          <b-btn @click="action('result', row.item)" size="sm" variant="primary">최근 결과</b-btn>
          <b-btn class="btn-add" @click="action('site', row.item)" size="sm" variant="success">사이트 설정</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center":limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
